import { PropType } from "vue";
import { ImageCdnService, MediaLibraryServiceComposable, TrackingServiceComposable, UseDrawerComposableService } from "./plugins/types";
import { CaptureErrorFunc } from "./use-error-logger";

export const richTextEditorProps = {
  value: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    required: false,
    default: null,
  },
  originalContent: {
    type: String,
    required: false,
    default: null,
  },
  identifier: {
    type: String,
    required: true,
  },
  height: {
    type: String,
    required: true,
  },
  menubar: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  /**
   * Composable which can be used to control our media library drawer, used to
   * provide image browsing and insertion capabilities for the editor.
   */
  useMediaLibraryService: {
    type: Function as PropType<MediaLibraryServiceComposable>,
    required: true,
  },
  useTrackingService: {
    type: Function as PropType<TrackingServiceComposable>,
    required: true,
  },
  imageCdnService: {
    type: Object as PropType<ImageCdnService>,
    required: true,
  },
  useDrawerService: {
    type: Function as PropType<UseDrawerComposableService>,
    required: true,
  },
}

export const internalRichTextEditorProps = {
  ...richTextEditorProps,
  captureError: {
    type: Function as PropType<CaptureErrorFunc>,
    required: true,
  },
};
